/* ============================================================
   dercomputerladen Shopify Theme – theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Helper ─────────────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ── Header Search Toggle ────────────────────────────────── */
  function initSearch() {
    const toggleBtn = $('#search-toggle');
    const closeBtn  = $('#search-close');
    const searchBar = $('#search-bar');
    const input     = $('#search-input');

    if (!toggleBtn || !searchBar) return;

    function openSearch() {
      searchBar.classList.add('is-open');
      input && setTimeout(() => input.focus(), 320);
    }
    function closeSearch() {
      searchBar.classList.remove('is-open');
    }

    toggleBtn.addEventListener('click', () => {
      searchBar.classList.contains('is-open') ? closeSearch() : openSearch();
    });
    closeBtn && closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSearch();
    });
  }

  /* ── Mobile Nav Toggle ───────────────────────────────────── */
  function initMobileNav() {
    const btn     = $('#mobile-menu-toggle');
    const mobileNav = $('#mobile-nav');
    if (!btn || !mobileNav) return;

    btn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      // Animate hamburger to X
      const spans = $$('span', btn);
      if (open) {
        spans[0].style.cssText = 'transform: translateY(7px) rotate(45deg)';
        spans[1].style.cssText = 'opacity:0; transform: scaleX(0)';
        spans[2].style.cssText = 'transform: translateY(-7px) rotate(-45deg)';
      } else {
        spans.forEach(s => s.style.cssText = '');
      }
    });
  }

  /* ── Hero Slideshow ──────────────────────────────────────── */
  function initSlideshow() {
    const section   = $('#hero-slideshow');
    if (!section) return;

    const slides    = $$('.slide', section);
    const dots      = $$('.dot', section);
    const prevBtn   = $('#slideshow-prev');
    const nextBtn   = $('#slideshow-next');

    if (slides.length <= 1) return;

    let current = 0;
    let timer;

    // Read autoplay speed from data-speed attribute (set by Liquid)
    const speed = (parseInt(section.dataset.speed) || 5) * 1000;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');

      current = (idx + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function startAuto() {
      timer = setInterval(() => goTo(current + 1), speed);
    }

    function stopAuto() {
      clearInterval(timer);
    }

    function resetAuto() {
      stopAuto();
      startAuto();
    }

    prevBtn && prevBtn.addEventListener('click', () => { goTo(current - 1); resetAuto(); });
    nextBtn && nextBtn.addEventListener('click', () => { goTo(current + 1); resetAuto(); });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goTo(i); resetAuto(); });
    });

    // Swipe support
    let touchStartX = 0;
    section.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    section.addEventListener('touchend', (e) => {
      const delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 50) {
        delta > 0 ? goTo(current + 1) : goTo(current - 1);
        resetAuto();
      }
    });

    // Pause on hover
    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);

    startAuto();
  }

  /* ── Cart: Quick Add ─────────────────────────────────────── */
  function initQuickAdd() {
    document.addEventListener('submit', async function (e) {
      const form = e.target;
      if (!form.classList.contains('product-card-add-form')) return;
      e.preventDefault();

      const btn = form.querySelector('.product-card-buy-btn') || form.querySelector('.quick-add-btn');
      if (!btn) {
        // Kein Button gefunden – normal abschicken
        form.submit();
        return;
      }

      const originalContent = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Wird hinzugefügt…';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Cart add failed');

        // Warenkorb-Zähler aktualisieren
        const cartCount = document.getElementById('cart-count');
        if (cartCount) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          cartCount.textContent = cart.item_count;
        }

        btn.innerHTML = '✓ Hinzugefügt!';
        btn.style.background = '#22c55e';

        setTimeout(() => {
          btn.innerHTML = originalContent;
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);

      } catch (err) {
        btn.innerHTML = '⚠ Fehler';
        setTimeout(() => {
          btn.innerHTML = originalContent;
          btn.disabled = false;
        }, 2000);
      }
    });
  }

  /* ── Header scroll effect ────────────────────────────────── */
  function initHeaderScroll() {
    const header = document.getElementById('site-header');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 80) {
        header.style.boxShadow = '0 2px 32px rgba(0,0,0,.35)';
      } else {
        header.style.boxShadow = '0 2px 20px rgba(0,0,0,.25)';
      }
      lastScroll = y;
    }, { passive: true });
  }

  /* ── Spin animation for loading states ───────────────────── */
  const style = document.createElement('style');
  style.textContent = '.spin { animation: spin .8s linear infinite; } @keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

  /* ── Mobile Sidebar Overlay ──────────────────────────────── */
  function initMobileSidebarOverlay() {
    const sidebar = document.getElementById('collection-sidebar');
    if (!sidebar) return;

    const overlay = document.createElement('div');
    overlay.id = 'sidebar-overlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:499;';
    document.body.appendChild(overlay);

    function openSidebar() {
      sidebar.classList.add('is-open');
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
    function closeSidebar() {
      sidebar.classList.remove('is-open');
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    overlay.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSidebar(); });

    const mobileToggle = document.getElementById('mobile-filter-toggle');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function() {
        sidebar.classList.contains('is-open') ? closeSidebar() : openSidebar();
        this.setAttribute('aria-expanded', sidebar.classList.contains('is-open'));
      });
    }
  }

  /* ── Init ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initSearch();
    initMobileNav();
    initSlideshow();
    initQuickAdd();
    initHeaderScroll();
    initMobileSidebarOverlay();
  });

})();
  /* ── Links extern im neuen Tab öffnen ────────────────────────────────────────────────── */
function externalLinks() {
  for(var c = document.getElementsByTagName("a"), a = 0; a < c.length; a++) {
    var b = c[a];
    b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank");
  }
};
externalLinks();
